module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-475w.a1729dc9.jpg";